import React from 'react';
import { styled } from '@mui/material';
import clsx from 'clsx';
import { getStatusUtilityClass, statusClasses } from './constants';
import { StatusProps } from './types';
import getTransition from '../utilities/getTransition';
import { badgeClasses } from '../badge';

function StatusComponent(props: StatusProps) {
  const {
    className, size = 'lg', state = 'unknown', ...rest
  } = props;

  return (
    <span
      className={
        clsx(
          className,
          statusClasses.root,
          getStatusUtilityClass(size),
          getStatusUtilityClass(state),
        )
      }
      {...rest}
    />
  );
}

export const Status = styled(StatusComponent)<StatusProps>(
  ({ theme, color, state }) => ({
    [`&.${statusClasses.root}`]: {
      display: 'inline-block',
      backgroundColor: theme.palette.status.unknown,
      color: theme.palette.status.unknown,
      borderColor: theme.palette.common.white,
      borderStyle: 'solid',
      borderRadius: '100%',
      ...getTransition(['background-color', 'border-width', 'color']),
      [`&.${statusClasses.sm}, .${badgeClasses.sm} .${badgeClasses.badge} > &`]: {
        width: 8,
        height: 8,
        borderWidth: 1,
      },
      [`&.${statusClasses.md}, .${badgeClasses.md} .${badgeClasses.badge} > &`]: {
        width: 10,
        height: 10,
        borderWidth: 2,
      },
      [`&.${statusClasses.lg}, .${badgeClasses.lg} .${badgeClasses.badge} > &`]: {
        width: 12,
        height: 12,
        borderWidth: 2,
      },
      [`&.${statusClasses.xl}, .${badgeClasses.xl} .${badgeClasses.badge} > &`]: {
        width: 14,
        height: 14,
        borderWidth: 2,
      },
      ...(state && {
        backgroundColor: theme.palette.status[state],
        color: theme.palette.status[state],
      }),
      ...(color && {
        backgroundColor: color,
        color,
      }),
    },
  }),
);
